import React, { useState } from "react";

import mvpIcon from "../assets/images/mvp.png";

export default function LeaderBoardCard({
  content,
  rank,
  projectName,
  collegeName,
}) {
  return (
    <div className="leaderboard-card">
      <div>
        <span>{rank}</span>
      </div>

      <div>
        <span>{projectName}</span>
      </div>

      <div>
        <span>{collegeName}</span>
      </div>

      <div>
        <div>
          {content?.map((item, index) => {
            return (
              <div key={index} className="leaderboard-card__container">
                <div className="leaderboard-card__container--user-info">
                  <div className="leaderboard-card__avatar-wrapper">
                    <img src={item.avatar_url} alt="" srcset="" />
                  </div>
                  <div>
                    <span className="">{item.login}</span>
                  </div>
                </div>

                <div className="leaderboard-card__mvp">
                  {item?.isMVP ? <img src={mvpIcon} alt="" srcset="" /> : null}
                </div>

                <div className="leaderboard-card__contributions">
                  <span>{item.contributions}</span>
                </div>

                {/* <div className="leaderboard-card__container--repo">
                <a href={item.url}>Visit Repo</a>
              </div> */}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
